export default defineNuxtPlugin(() => {
	const config = useRuntimeConfig()
	if (config.public.environment !== 'production-to-change') console.log('You are in ' + config.public.environment + ' mode')
	else {
		console.log = function () {
			return false
		}
	}
})
